import NivelPrioridadService from 'src/modules/nivelPrioridad/nivelPrioridadService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';

const prefix = 'NIVELPRIORIDAD_FORM';

const nivelPrioridadFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: nivelPrioridadFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await NivelPrioridadService.find(id);
      }

      dispatch({
        type: nivelPrioridadFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: nivelPrioridadFormActions.INIT_ERROR,
      });

      getHistory().push('/nivel-prioridad');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: nivelPrioridadFormActions.CREATE_STARTED,
      });

      await NivelPrioridadService.create(values);

      dispatch({
        type: nivelPrioridadFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.nivelPrioridad.create.success'),
      );

      getHistory().push('/nivel-prioridad');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: nivelPrioridadFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: nivelPrioridadFormActions.UPDATE_STARTED,
      });

      await NivelPrioridadService.update(id, values);

      dispatch({
        type: nivelPrioridadFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.nivelPrioridad.update.success'),
      );

      getHistory().push('/nivel-prioridad');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: nivelPrioridadFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default nivelPrioridadFormActions;
